import '../style.scss';

import * as Sentry from '@sentry/browser';
import React, { useEffect, useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useNavigate } from 'react-router-dom';
import { Form } from 'reactstrap';

import firebaseApp from '@/config/firebase.config';

const LoginPage = () => {
  const navigate = useNavigate();
  const [loaderStyle, setLoaderStyle] = useState({});
  const [error, setError] = useState({ show: false, title: '', message: '' });
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoaderStyle({ display: 'none' });
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleSignIn = async (event) => {
    event.preventDefault();
    try {
      const user = await firebaseApp
        .auth()
        .signInWithEmailAndPassword(email, password);
      Sentry.setUser({ email });
      console.log(JSON.stringify(user));
      navigate('/cigars/manager');
    } catch (e) {
      setError({
        show: true,
        title: 'Unable To Log In',
        message: e.message,
      });
    }
  };

  const closeAlert = () => {
    setError({ show: false, title: '', message: '' });
  };

  return (
    <div>
      <div className="loader-wrapper" style={loaderStyle}>
        <div className="loader bg-white">
          <div className="line bg-primary" />
          <div className="line bg-primary" />
          <div className="line bg-primary" />
          <div className="line bg-primary" />
          <div className="line bg-primary" />
          <h4>
            {"'Bout that time..."} <span>&#x1F4A8;</span>
          </h4>
        </div>
      </div>

      <SweetAlert
        show={error.show}
        type="danger"
        title={error.title}
        onConfirm={closeAlert}
      >
        {error.message}
      </SweetAlert>

      <div className="authentication-wrapper">
        <div className="authentication-wrapper__background" />
        <div className="card authentication-main">
          <div className="authentication-box">
            <img
              src={require('../../../assets/images/logo-v2.png')}
              alt=""
              style={{ height: 30 }}
            />
            <div style={{ margin: '20px 0' }}>
              <h4>Log In</h4>
              <h6>Authorized access only</h6>
            </div>
            <div>
              <Form className="theme-form" onSubmit={handleSignIn}>
                <div className="form-group">
                  <label className="col-form-label pt-0">Email</label>
                  <input
                    required
                    type="text"
                    name="email"
                    className="form-control form-control-lg"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label className="col-form-label">Password</label>
                  <input
                    required
                    type="password"
                    name="password"
                    className="form-control form-control-lg"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div className="form-group form-row mt-3">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ width: '100%' }}
                  >
                    LOG IN
                  </button>
                </div>
                <p style={{ marginTop: 16 }}>
                  Looking for our app?{' '}
                  <a href="https://accounts.boxpressd.com/">Log in here ➞</a>
                </p>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
